import { render, staticRenderFns } from "./notes-container.vue?vue&type=template&id=2d1e2ec0"
import script from "./notes-container.vue?vue&type=script&lang=ts"
export * from "./notes-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports